export default "__VITE_ASSET__Ds$rxpqS__"